import { NgClass } from '@angular/common';
import { Component, computed, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { Events } from '@app/core/models/event-map';
import { PublishSubscribeService } from '@app/core/services/publish-subscribe.service';
import { UserService } from '@app/shared/services/User.Service';
import { UserContextSelectors } from '@app/shared/state/user-context/user-context.selectors';
import { environment } from '@environments/environment';
import { Store } from '@ngxs/store';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { map, Subscription } from 'rxjs';
import { LogoComponent } from '../logo/logo.component';
import { TopNavComponent } from '../top-nav/top-nav.component';

@Component({
  selector: 'kp-header',
  imports: [LogoComponent, TopNavComponent, TooltipModule, NgClass],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {

  axEnv = signal<string>('');
  selectedUserFullName = signal<string>('')

  #destroyRef = inject(DestroyRef)
  #publishSubscribeService = inject(PublishSubscribeService)
  #userInternalService = inject(UserService)
  #store = inject(Store)
  #subscriptions: Subscription[] = []
  #activatedRoute = inject(ActivatedRoute)

  isMf = this.#store.selectSignal(UserContextSelectors.isMf)
  readonly dSignal = toSignal(
    this.#activatedRoute.queryParamMap.pipe(
      map(params => params.get('d'))
    ),
    { initialValue: null }
  );

  reloadForMfStyles = computed(() => {
    const isMf = this.isMf()
    const params = this.dSignal()
    const isLocalhost = window.location.hostname === 'localhost'
    return isMf && params !== 'mf' && isLocalhost
  })

  isLoggedIn = this.#store.selectSignal(UserContextSelectors.isAuthenticated)

  ngOnInit(): void {
      this.axEnv.set(environment.axEnv)

      this.setSelectedUserFullName();

      this.#subscriptions.push(
          this.#publishSubscribeService.on(Events.UserService.SELECTED_USER_CHANGED).pipe(
              takeUntilDestroyed(this.#destroyRef)
          )
          .subscribe({
              next: () => {
                  this.handleEvent_UserService_SELECTED_USER_CHANGED()
              }
          })
      )
  }

  setSelectedUserFullName(): void {

      const portalUser_LoggedIn = this.#userInternalService.getPortalUser_LoggedIn();
      const portalUser_Selected = this.#userInternalService.getPortalUser_Selected();

      if (portalUser_LoggedIn != undefined && portalUser_Selected != undefined && portalUser_LoggedIn.USERID !== portalUser_Selected.USERID) {
          this.selectedUserFullName.set(portalUser_Selected.USERFULLNAME);
      }
      else {
          this.selectedUserFullName.set('');
      }
  }

  handleEvent_UserService_SELECTED_USER_CHANGED(): void {
      this.setSelectedUserFullName();
  }

  addMfDomainParam() {
    if(this.reloadForMfStyles()) {
      const url = new URL(window.location.href);
      url.searchParams.set('d', 'mf');
      window.location.replace(url.toString());
    }
  }
}
